import { css, styled } from '@styles/theme'

export const stylesSimulatedExam = {
	CardSimulateResult: styled('div', {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',

		width: '283px',
		height: '81px',
		background: '$neutral10',
		border: '1px solid $neutral50',
		borderRadius: '12px',
		padding: '8px 15px',

		'&:hover': {
			color: '$blue20',
		},
	}),

	containerCards: css({
		display: 'flex',
		alignItems: 'center',
		gap: '25px',
		flexWrap: 'wrap',
	}),

	titleResult: css({
		marginBottom: '24px',
	}),

	containerNewSimulate: css({
		width: '100%',
	}),

	iconNewSimulate: css({
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		minWidth: '48px',
		height: '48px',
		background: '$primary',
		borderRadius: '8px',

		color: '$neutral10',
	}),

	ActionBar: styled('button', {
		display: 'flex',
		alignItems: 'center',
		gap: '10px',

		p: {
			_font: 'normal',
			fontWeight: 500,
			fontSize: '14px',
			lineHeight: '21px',
			letterSpacing: '0.05em',
			color: '$neutral100',
		},

		'&:hover': {
			color: '$primary',
			svg: {
				color: '$primary',
			},
			p: {
				color: '$primary',
			},
		},

		variants: {
			selected: {
				true: {
					p: {
						color: '$primary',
					},
					svg: {
						color: '$primary',
					},
				},
			},
		},
	}),

	Icon: styled('div', {
		display: 'flex',
		alignItems: 'center',

		width: '25px',
		height: '25px',
		borderRadius: '6px',
		justifyContent: 'center',
		color: '$neutral100',

		svg: {
			width: '20px',
			height: '20px',
		},
	}),

	containerActionBar: css({
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		width: '100%',
		minHeight: ' 83px',
		padding: '16px',
		margin: '32px 0px',
		gap: '40px',

		background: '$neutral10',
		border: '1px solid $neutral50',
		borderRadius: '12px',

		cursor: 'pointer',
	}),

	containerStatistic: css({
		display: 'flex',
		justifyContent: 'space-around',
		padding: '34px',
		background: '$neutral10',
		borderRadius: '12px',
		marginBottom: '30px',
		gap: '10px',
	}),

	cardStatistic: css({
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		gap: '26px',
		width: '100%',
		maxWidth: '490px',
		minHeight: '209px',
		background: 'linear-gradient(90deg, $blue20 1.23%, $neutral50 100%)',
		borderRadius: '14px',
		padding: '20px',
		color: '$neutral10',

		h4: {
			color: '$neutral10',
			_font: 'normal',
			fontSize: '$xxl',
			fontWeight: '700',
		},

		h5: {
			color: '$neutral10',
			_font: 'normal',
			fontSize: '$xxl',
			fontWeight: '500',
		},
	}),
}
